﻿export class Param {
    id: number;
    clave: string;
    valor: string;
}
